/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Overlay_Lock_LabelInputs */

const bn_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তালা`)
};

const de_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPERREN`)
};

const el_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΚΛΕΙΔΑΡΙΑ`)
};

const en_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LOCK`)
};

const es_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CERRAR`)
};

const fr_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VERROU`)
};

const hi_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ताला`)
};

const hu_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZÁR`)
};

const id_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KUNCI`)
};

const it_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SERRATURA`)
};

const ja_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロック`)
};

const ko_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠그다`)
};

const nl_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLOT`)
};

const pl_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZAMEK`)
};

const pt_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRANCAR`)
};

const ru_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗАМОК`)
};

const sv_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LÅSA`)
};

const tr_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KİLİT`)
};

const uk_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗАМОК`)
};

const vi_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KHÓA`)
};

const zh_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁`)
};

const zh_hant_cipher_overlay_lock_label = /** @type {(inputs: Cipher_Overlay_Lock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鎖`)
};

/**
* | output |
* | --- |
* | "LOCK" |
*
* @param {Cipher_Overlay_Lock_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_overlay_lock_label = /** @type {((inputs?: Cipher_Overlay_Lock_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Overlay_Lock_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_overlay_lock_label(inputs)
	if (locale === "de") return de_cipher_overlay_lock_label(inputs)
	if (locale === "el") return el_cipher_overlay_lock_label(inputs)
	if (locale === "en") return en_cipher_overlay_lock_label(inputs)
	if (locale === "es") return es_cipher_overlay_lock_label(inputs)
	if (locale === "fr") return fr_cipher_overlay_lock_label(inputs)
	if (locale === "hi") return hi_cipher_overlay_lock_label(inputs)
	if (locale === "hu") return hu_cipher_overlay_lock_label(inputs)
	if (locale === "id") return id_cipher_overlay_lock_label(inputs)
	if (locale === "it") return it_cipher_overlay_lock_label(inputs)
	if (locale === "ja") return ja_cipher_overlay_lock_label(inputs)
	if (locale === "ko") return ko_cipher_overlay_lock_label(inputs)
	if (locale === "nl") return nl_cipher_overlay_lock_label(inputs)
	if (locale === "pl") return pl_cipher_overlay_lock_label(inputs)
	if (locale === "pt") return pt_cipher_overlay_lock_label(inputs)
	if (locale === "ru") return ru_cipher_overlay_lock_label(inputs)
	if (locale === "sv") return sv_cipher_overlay_lock_label(inputs)
	if (locale === "tr") return tr_cipher_overlay_lock_label(inputs)
	if (locale === "uk") return uk_cipher_overlay_lock_label(inputs)
	if (locale === "vi") return vi_cipher_overlay_lock_label(inputs)
	if (locale === "zh") return zh_cipher_overlay_lock_label(inputs)
	return zh_hant_cipher_overlay_lock_label(inputs)
});